import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import kb_markup from "ulysses/features/knowledge_base.html";
import "ulysses/widgets";

$(document).ready(function() {
    $(kb_markup).appendTo($("body"));
});

ko.bindingHandlers.knowledgelist = {
    init: function(elt, va, allbindings, model, context) {
        var search_settings = ko.observable({
                "navigable":false,
                "contextual":false,
                "facets_visible": false,
                "show_controls": false,
                "selection_aware": false,
                "actions_visible": false,
                "search_placeholder": _('search_knowledge_placeholder', 'Search Knowledge Articles'),
                "filter":"type:article",
                "parameters": { _search_body:null }
        });

        let sub = uly.page.active_entity.subscribe((newvalue)=> {
            console.warn("New active entity:", newvalue);
            get_relevance_filter().then((filterstr) => {
                let settings = search_settings();
                let filter = filterstr || "type:article";
                var model = $(elt).children(".search").data("search_model");

                if (settings.filter !== filter) {
                    let new_settings = Object.assign({}, settings, { filter: filter });
                    search_settings(new_settings);
                    //hack to get at the model
                    model.query_results();
                }
            });
        });

        ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
            sub.dispose();
            sub = null;
        });

        var child = context.createChildContext({"settings": search_settings });
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    }
};

function get_relevance_filter() {
    let entity = uly.page.active_entity();
    if (entity) {
        return HalResource(entity).follow("uly:knowledge").then((res) => {
            return res.filter;
        }, () => { return ""; })
    } else {
        return Promise.resolve("");
    }
}

$.extend(uly.actions, {
    open_kb:function(ev,$elt,ui) {
        uly.actions.navigateto("/search?filters=type:article");
        return false;
    },
});
